import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { KeyboardType } from '../components/keyboard/keyboard.component';

export interface KeyboardData {
	isShow?: boolean;
	theme?: KeyboardType;
	formFields?: string[];
	formValues?: object;
	isValid?: boolean;
	formErrors?: object;
	fieldFocused?: string;
	resetValues?: boolean;
	input?: boolean;
	cursorPosition?: number;
}
@Injectable()
export class KeyboardService {
	private keyBoardSubject = new BehaviorSubject<any>({
		isShow: false,
		theme: KeyboardType.IOS,
		formFields: ['email', 'repeat_email'],
		formValues: {},
		formErrors: {},
		isValid: false,
		resetValues: false,
		fieldFocused: 'email',
		input: '',
		cursorPosition: undefined,
	});
	keyboard$: Observable<any> = this.keyBoardSubject.asObservable();

	public keyboardEvent: EventEmitter<string> = new EventEmitter<string>();

	show() {
		this.keyBoardSubject.next({ ...this.keyBoardSubject.value, isShow: true });
	}

	hide() {
		this.keyBoardSubject.next({ ...this.keyBoardSubject.value, isShow: false });
	}

	setKeyboarData(keyboard: KeyboardData) {
		const current = this.keyBoardSubject.value;
		const formValues =
			keyboard.formValues !== undefined ? { ...current.formValues, ...keyboard.formValues } : current.formValues;
		const formErrors =
			keyboard.isValid === true
				? {}
				: keyboard.formErrors !== undefined
					? { ...current.formErrors, ...keyboard.formErrors }
					: current.formErrors;
		this.keyBoardSubject.next({
			...current,
			...keyboard,
			formValues,
			formErrors,
		});
	}

	setKeyboarForm(formValues: Record<string, unknown>) {
		this.keyBoardSubject.next({
			...this.keyBoardSubject.value,
			formValues: { ...formValues },
		});
	}

	getKeyboarData() {
		return this.keyBoardSubject.value;
	}

	isFormValid() {
		return this.keyBoardSubject.value.isValid;
	}

	resetKeyboard(formFields?: string[]) {
		this.keyBoardSubject.next({
			isShow: false,
			theme: KeyboardType.IOS,
			formFields: formFields ?? ['email', 'repeat_email'],
			formValues: {},
			formErrors: {},
			isValid: false,
			cursorPosition: undefined,
		});
	}

	updateInput(value: string) {
		this.keyBoardSubject.next({
			...this.keyBoardSubject.value,
			input: value,
		});
	}

	emitKeyboardEvent(value: string) {
		this.keyboardEvent.emit(value);
	}
}
